import React, { useState } from "react";
import API from "../services/api";
import Swal from "sweetalert2";
import { FaEnvelope, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import Loader from "./Loader"; // Import your loader
import "./LoginPage.css";

function LoginPage({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Start loader
    try {
      const response = await API.post("/Auth/login", {
        email,
        password,
      });

      if (response.data.status === true) {
        onLogin(response.data.data, response.data.data.token);
      }
    } catch (error) {
      console.error("Login failed", error);
    } finally {
      setLoading(false); // Stop loader
    }
  };


  return (
    <div className="app-container">
      {/* Loader overlay */}
      <Loader isLoading={loading} message="Signing In..." />

      <div className="glass-card">
        <div className="header-section">
          <img src="/mtlogo.jpg" alt="Mahendra Traders Logo" className="app-logo" />
          <h1>Welcome</h1>
          <p>Mahendra Traders</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="input-container">
            <FaEnvelope className="input-icon" />
            <input
              type="text"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="input-container">
            <FaLock className="input-icon" />
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <div className="eye-icon" onClick={() => setShowPassword(!showPassword)}>
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </div>
          </div>

          <button type="submit" className="login-button" disabled={loading}>
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginPage;





// import React, { useState } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { FaEnvelope, FaLock, FaSignInAlt, FaEye, FaEyeSlash } from "react-icons/fa";
// import "./LoginPage.css";

// function LoginPage({ onLogin }) {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
     
//        const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

//     // POST request
//      const response = await axios.post(`${API_BASE_URL}/Auth/login`, {
//       email,
//       password
//     });
//       if (response.data.status === true) {
//         onLogin(response.data.data, response.data.data.token);
//       } else {
//         Swal.fire({ icon: "error", title: "Failed", text: response.data.message });
//       }
//     } catch (error) {
//       Swal.fire({ icon: "error", title: "Error", text: "Check your connection" });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="app-container">
//       <div className="glass-card">
//        <div className="header-section">
//   <img src="/mtlogo.jpg" alt="Mahendra Traders Logo" className="app-logo" />
//   <h1>Welcome</h1>
//   <p>Mahendra Traders</p>
// </div>

//         <form onSubmit={handleSubmit} className="login-form">
//           <div className="input-container">
//             <FaEnvelope className="input-icon" />
//             <input
//               type="text"
//               placeholder="Email Address"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               required
//             />
//           </div>

//           <div className="input-container">
//             <FaLock className="input-icon" />
//             <input
//               type={showPassword ? "text" : "password"}
//               placeholder="Password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               required
//             />
//             <div className="eye-icon" onClick={() => setShowPassword(!showPassword)}>
//               {showPassword ? <FaEyeSlash /> : <FaEye />}
//             </div>
//           </div>
//           <button type="submit" className="login-button" disabled={loading}>
//             {loading ? <div className="spinner"></div> : "Sign In"}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// }

// export default LoginPage;



// import React, { useState } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import {
//   FaEnvelope,
//   FaLock,
//   FaSignInAlt,
//   FaEye,
//   FaEyeSlash,
//   FaUserCircle,
// } from "react-icons/fa";

// function LoginPage({ onLogin }) {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!email || !password) {
//       Swal.fire({
//         icon: "warning",
//         title: "Required!",
//         text: "Please fill all fields",
//         confirmButtonColor: "#667eea",
//       });
//       return;
//     }

//     setLoading(true);

//     try {
//       const response = await axios.post(
//         "https://localhost:7199/api/Auth/login",
//         { email, password }
//       );

//       if (response.data.status === true) {
//         const { token, username, email: userEmail } = response.data.data;

//         Swal.fire({
//           icon: "success",
//           title: "Welcome!",
//           text: `Hello, ${username}!`,
//           timer: 1500,
//           showConfirmButton: false,
//         });

//         onLogin({ username, email: userEmail }, token);
//       } else {
//         Swal.fire({
//           icon: "error",
//           title: "Failed",
//           text: response.data.message || "Invalid credentials",
//           confirmButtonColor: "#667eea",
//         });
//       }
//     } catch (error) {
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Invalid email or password",
//         confirmButtonColor: "#667eea",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div
//       className="min-vh-100 d-flex align-items-center justify-content-center p-3 p-md-4"
//       style={{
//         background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//         position: "relative",
//         overflow: "hidden",
//       }}
//     >
//       {/* Floating Shapes */}
//       <div
//         className="floating-shape d-none d-md-block"
//         style={{
//           width: "300px",
//           height: "300px",
//           top: "-100px",
//           left: "-100px",
//         }}
//       ></div>
//       <div
//         className="floating-shape d-none d-md-block"
//         style={{
//           width: "200px",
//           height: "200px",
//           bottom: "-50px",
//           right: "-50px",
//           animationDelay: "2s",
//         }}
//       ></div>
//       <div
//         className="floating-shape d-none d-lg-block"
//         style={{
//           width: "150px",
//           height: "150px",
//           top: "50%",
//           right: "15%",
//           animationDelay: "4s",
//         }}
//       ></div>
//       <div
//         className="floating-shape d-none d-lg-block"
//         style={{
//           width: "100px",
//           height: "100px",
//           bottom: "20%",
//           left: "10%",
//           animationDelay: "3s",
//         }}
//       ></div>

//       {/* Login Card */}
//       <div
//         className="card border-0 fade-in w-100"
//         style={{
//           maxWidth: "420px",
//           borderRadius: "20px",
//           boxShadow: "0 25px 50px rgba(0, 0, 0, 0.25)",
//           position: "relative",
//           zIndex: 1,
//         }}
//       >
//         <div className="card-body p-4 p-md-5">
//           {/* Logo */}
//           <div className="text-center mb-4">
//             <div
//               className="mx-auto mb-3"
//               style={{
//                 width: "70px",
//                 height: "70px",
//                 background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                 borderRadius: "50%",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 boxShadow: "0 10px 30px rgba(102, 126, 234, 0.4)",
//               }}
//             >
//               <FaUserCircle style={{ fontSize: "35px", color: "white" }} />
//             </div>
//             <h2
//               className="fw-bold mb-1"
//               style={{ color: "#333", fontSize: "clamp(22px, 5vw, 28px)" }}
//             >
//               Welcome Back
//             </h2>
//             <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
//               Sign in to continue
//             </p>
//           </div>

//           {/* Form */}
//           <form onSubmit={handleSubmit}>
//             {/* Email */}
//             <div className="mb-3 mb-md-4">
//               <label
//                 className="form-label fw-semibold"
//                 style={{ color: "#555", fontSize: "14px" }}
//               >
//                 Email Address
//               </label>
//               <div className="input-group">
//                 <span
//                   className="input-group-text"
//                   style={{
//                     background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                     border: "none",
//                     color: "white",
//                     borderRadius: "10px 0 0 10px",
//                   }}
//                 >
//                   <FaEnvelope />
//                 </span>
//                 <input
//                   type="email"
//                   className="form-control"
//                   placeholder="Enter your email"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   style={{
//                     border: "2px solid #e1e5eb",
//                     borderLeft: "none",
//                     fontSize: "15px",
//                     padding: "12px 15px",
//                     borderRadius: "0 10px 10px 0",
//                   }}
//                   required
//                 />
//               </div>
//             </div>

//             {/* Password */}
//             <div className="mb-3 mb-md-4">
//               <label
//                 className="form-label fw-semibold"
//                 style={{ color: "#555", fontSize: "14px" }}
//               >
//                 Password
//               </label>
//               <div className="input-group">
//                 <span
//                   className="input-group-text"
//                   style={{
//                     background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                     border: "none",
//                     color: "white",
//                     borderRadius: "10px 0 0 10px",
//                   }}
//                 >
//                   <FaLock />
//                 </span>
//                 <input
//                   type={showPassword ? "text" : "password"}
//                   className="form-control"
//                   placeholder="Enter your password"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   style={{
//                     border: "2px solid #e1e5eb",
//                     borderLeft: "none",
//                     borderRight: "none",
//                     fontSize: "15px",
//                     padding: "12px 15px",
//                   }}
//                   required
//                 />
//                 <span
//                   className="input-group-text"
//                   style={{
//                     background: "white",
//                     border: "2px solid #e1e5eb",
//                     borderLeft: "none",
//                     cursor: "pointer",
//                     borderRadius: "0 10px 10px 0",
//                   }}
//                   onClick={() => setShowPassword(!showPassword)}
//                 >
//                   {showPassword ? (
//                     <FaEyeSlash color="#888" />
//                   ) : (
//                     <FaEye color="#888" />
//                   )}
//                 </span>
//               </div>
//             </div>

//             {/* Remember & Forgot */}
//             <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mb-4 gap-2">
//               <div className="form-check">
//                 <input
//                   type="checkbox"
//                   className="form-check-input"
//                   id="remember"
//                   style={{ cursor: "pointer" }}
//                 />
//                 <label
//                   className="form-check-label"
//                   htmlFor="remember"
//                   style={{ fontSize: "13px", color: "#666", cursor: "pointer" }}
//                 >
//                   Remember me
//                 </label>
//               </div>
//               <a
//                 href="#"
//                 style={{
//                   fontSize: "13px",
//                   color: "#667eea",
//                   textDecoration: "none",
//                   fontWeight: "500",
//                 }}
//               >
//                 Forgot Password?
//               </a>
//             </div>

//             {/* Submit Button */}
//             <button
//               type="submit"
//               className="btn w-100 btn-hover"
//               disabled={loading}
//               style={{
//                 background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                 border: "none",
//                 color: "white",
//                 padding: "14px",
//                 borderRadius: "10px",
//                 fontWeight: "600",
//                 fontSize: "16px",
//                 boxShadow: "0 10px 30px rgba(102, 126, 234, 0.4)",
//               }}
//             >
//               {loading ? (
//                 <>
//                   <span className="spinner-border spinner-border-sm me-2"></span>
//                   Signing in...
//                 </>
//               ) : (
//                 <>
//                   <FaSignInAlt className="me-2" />
//                   Sign In
//                 </>
//               )}
//             </button>
//           </form>

         
           
          
//         </div>
//       </div>
//     </div>
//   );
// }

// export default LoginPage;